
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/page/[id]",
      function () {
        return require("private-next-pages/cases/page/[id].tsx");
      }
    ]);
  